import template from './add-form.jade';
import { AddFormCtrl } from './add-form.controller';
import './add-form.css';

export default [
  'addFormService',
  function (addFormService) {
    return {
      template,
      scope: {},
      bindToController: {
        ad: '=',
        savedAd: '=',
        user: '=',
        regions: '=',
        countryCodes: '=',
      },
      link(scope, element, attrs, ctrl) {
        addFormService.provideForm(ctrl.form);
        addFormService.provideNeedHideRestForm(ctrl.needHideRestForm);
      },
      controller: AddFormCtrl,
      controllerAs: 'addFormCtrl',
      replace: true,
    };
  },
];
